export default __webpack_public_path__ + "static/Commitment_to_Quality-0a8b6240723b90562eee6dec317a296a.pdf";